import BoardSvc from '@/common/service/modules/BoardSvc';

export default {
  async fetchNoticeList({ state, commit }) {
    const response = await BoardSvc.getNoticeList(state.reqPageInfo);
    const { code, entity } = response;
    if (code === 1) {
      await commit('setBoardList', { resBoardList: entity.list });
      await commit('setPageInfo', entity.pageInfo);

      if (state.reqPageInfo.page < state.pageInfo.totalPage) {
        await commit('setPage', state.reqPageInfo.page + 1);
      }
    }
  },

  async fetchAlarmList({ state, commit }, params) {
    const response = await BoardSvc.getAlarmList(params);
    const { code, entity } = response;
    if (code === 1) {
      await commit('setAlarmList', { resAlarmList: entity.list });
      await commit('setPageInfo', entity.pageInfo);

      if (state.reqPageInfo.page < state.pageInfo.totalPage) {
        await commit('setPage', state.reqPageInfo.page + 1);
      }
    }
  },

  async fetchFaqList({ state, commit }) {
    const response = await BoardSvc.getFaqList(state.reqPageInfo);
    const { code, entity } = response;
    if (code === 1) {
      commit('setFaqList', { resFaqList: entity.list });
      commit('setPageInfo', entity.pageInfo);

      if (state.reqPageInfo.page < state.pageInfo.totalPage) {
        commit('setPage', state.reqPageInfo.page + 1);
      }
    }
  },

  async fetchBoardDetail({ commit }, studentOrderNo) {
    const response = await BoardSvc.getBoardDetail(studentOrderNo);
    const { code, entity } = response;
    if (code === 1) {
      commit('setBoardInfo', entity);
    }
  },

  async fetchAlarmDetail({ commit }, studentOrderNo) {
    const response = await BoardSvc.getAlarmDetail(studentOrderNo);
    const { code, entity } = response;
    if (code === 1) {
      commit('setAlarmInfo', entity);
    }
  }
};
